export default __webpack_public_path__ + "static/media/settings-top-cloud.d00b85b9.svg";